import { createAsyncThunk } from '@reduxjs/toolkit';
import {
	getMerchantOrderCancelUrl,
	getMerchantOrderStatusUrl,
	getMerchantOrderUrl,
} from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import MerchantOrder, { MerchantOrderStatus } from '../../interfaces/MerchantOrder';

export const fetchOrder = createAsyncThunk(
	'ORDER/FETCH_ORDER',
	(id: string, { rejectWithValue }) => {
		return axiosInstance
			.get<MerchantOrder>(getMerchantOrderUrl(id))
			.then(({ data }) => data)
			.catch((e) => rejectWithValue(e.response?.data));
	}
);

export const fetchOrderStatus = createAsyncThunk('ORDER/FETCH_ORDER_STATUS', (id: string) => {
	return axiosInstance
		.get<{ status: MerchantOrderStatus; paidAmount: string }>(getMerchantOrderStatusUrl(id))
		.then(({ data }) => data);
});

export const cancelOrder = createAsyncThunk('ORDER/CANCEL', (id: string, { rejectWithValue }) => {
	return axiosInstance
		.post<{ status: MerchantOrderStatus }>(getMerchantOrderCancelUrl(id))
		.then(({ data }) => data)
		.catch((e) => rejectWithValue(e.response?.data));
});
